module.exports = ".wrapSimpleImage {\r\n    width: 100%;\r\n}\r\n\r\n.cell {\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/simple-image/simple-image.component.css
// module id = ./src/app/commons/simple-image/simple-image.component.css
// module chunks = main